import React, { useState } from 'react';
import Img from 'gatsby-image';
import { Parallax, Background } from 'react-parallax';
import { Link, graphql } from 'gatsby';
import Footer from '../components/footer';
import Layout from '../components/layout';
import SEO from '../components/seo';
import get from 'lodash/get';

const PostThumbnail = ({ node, index }) => (
    <div className="col-12 d-flex">
        <div className="card card-row shadow-light-lg mb-6 lift">
            <div className="row no-gutters">
                <Link
                    to={
                        node.fields.slug.substring(0, 4) === '/gr/'
                            ? node.fields.slug.substring(0, 9) + node.fields.slug.substring(12, node.fields.slug.length)
                            : node.fields.slug.substring(0, 6) + node.fields.slug.substring(9, node.fields.slug.length)
                    }
                    className={index % 2 ? 'col-12 col-md-6 order-md-2' : 'col-12 col-md-6'}
                    style={{ maxHeight: 350, overflow: 'hidden' }}
                >
                    <Img
                        fluid={node.frontmatter.featuredImage.childImageSharp.fluid}
                        alt={node.frontmatter.title}
                        className={index % 2 ? 'img-fluid card-img-right' : 'img-fluid card-img-left'}
                        style={{ height: '100%' }}
                    />
                    {index % 2 ? (
                        <>
                            <div className="shape shape-left shape-fluid-y svg-shim text-white d-none d-md-block">
                                <svg viewBox="0 0 112 690" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.14577e-06 0H62.7586V172C38.6207 384 112 517 112 517V690H2.14577e-06V0Z" fill="currentColor" />
                                </svg>
                            </div>
                            <div className="shape shape-bottom shape-fluid-x svg-shim text-white d-block d-md-none">
                                <svg viewBox="0 0 2880 480" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M2160 0C1440 240 720 240 720 240H0v240h2880V0h-720z"
                                        fill="currentColor"
                                    ></path>
                                </svg>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="shape shape-right shape-fluid-y svg-shim text-white d-none d-md-block">
                                <svg viewBox="0 0 112 690" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M116 0H51V172C76 384 0 517 0 517V690H116V0Z" fill="currentColor" />
                                </svg>
                            </div>
                            <div className="shape shape-bottom shape-fluid-x svg-shim text-white d-block d-md-none">
                                <svg viewBox="0 0 2880 480" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M2160 0C1440 240 720 240 720 240H0v240h2880V0h-720z"
                                        fill="currentColor"
                                    ></path>
                                </svg>
                            </div>
                        </>
                    )}
                </Link>
                <div className="col-12 col-md-6 order-md-1">
                    <Link
                        to={
                            node.fields.slug.substring(0, 4) === '/gr/'
                                ? node.fields.slug.substring(0, 9) + node.fields.slug.substring(12, node.fields.slug.length)
                                : node.fields.slug.substring(0, 6) + node.fields.slug.substring(9, node.fields.slug.length)
                        }
                        className="card-body"
                    >
                        <h3>{node.frontmatter.title}</h3>
                        <p className="mb-0 text-muted">{node.excerpt}</p>
                    </Link>
                    <Link
                        to={
                            node.fields.slug.substring(0, 4) === '/gr/'
                                ? node.fields.slug.substring(0, 9) + node.fields.slug.substring(12, node.fields.slug.length)
                                : node.fields.slug.substring(0, 6) + node.fields.slug.substring(9, node.fields.slug.length)
                        }
                        className={node.frontmatter.title.length > 36 ? 'card-meta' : 'card-meta pt-8'}
                    >
                        <hr className="card-meta-divider" />
                        <div className="avatar avatar-sm mr-6 mt-n4">
                            <Img
                                fixed={node.frontmatter.authorImage.childImageSharp.fixed}
                                alt={node.frontmatter.author}
                                className="avatar-img rounded-circle"
                            />
                        </div>
                        <h6 className="text-uppercase text-muted mr-2 mb-0">{node.frontmatter.author}</h6>
                        <p className="h6 text-uppercase text-muted mb-0 ml-auto">{node.frontmatter.date}</p>
                    </Link>
                </div>
            </div>
        </div>
    </div>
);

class BlogIndexTemplate extends React.Component {
    state = {
        search: ''
    };

    setSearch = (e) => {
        e.preventDefault();
        this.setState({ search: e.target.value });
    };

    submit = (e) => {
        e.preventDefault();
    };

    render() {
        const siteTitle = get(this, 'props.data.site.siteMetadata.title');
        const langKey = this.props.pageContext.langKey;
        const image = get(this, 'props.data.image.childImageSharp.fixed');
        const imageFluid = get(this, 'props.data.image.childImageSharp.fluid');
        const posts = get(this, 'props.data.allMarkdownRemark.edges');
        const { search } = this.state;
        let filteredPosts =
            posts && posts.length > 0
                ? posts.filter((post) => {
                      let searchable =
                          post.node.frontmatter.title + ' ' + post.node.frontmatter.author + ' ' + post.node.frontmatter.date + ' ' + post.node.excerpt;
                      let searchTerms = search
                          .toLowerCase()
                          .trim()
                          .split(' ');
                      return searchTerms.every((term) => {
                          return searchable.toLowerCase().includes(term);
                      });
                  })
                : [];
        return (
            <Layout location={this.props.location} title={siteTitle}>
                <SEO title="Blog" description="Find the best news articles, business tips, and activity guides for the watersports industry." />

                <Parallax strength={600} className="d-none d-lg-block">
                    <Background>
                        <Img fixed={image} />
                    </Background>
                    <div className="py-10 py-md-14 overlay overlay-40 overlay-secondary">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-12 col-md-10 col-lg-8 text-center">
                                    <h1 className="display-2 font-weight-bold text-white">{langKey === 'en' ? 'News & Blog' : 'Τα Νέα Μας'}</h1>
                                    <p className="lead mb-8 text-white font-weight-bold">
                                        {langKey === 'en'
                                            ? 'Learn about our latest news and activity of WeSolve Greece.'
                                            : 'Διάβασε τα πιο πρόφτατα άρθρα για τις δραστηριότητες του WeSolve.'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Parallax>
                <div className="d-lg-none img-cover mb-n8 bg-secondary pb-8">
                    <div className="w-100">
                        <Img fluid={imageFluid} style={{ opacity: 0.7 }} />
                        <div className="container mt-n12 mt-sm-n14 mb-8 mb-sm-13 mt-lg-0">
                            <div className="row justify-content-center">
                                <div className="col-12 col-md-10 col-lg-8 text-center">
                                    <h1 className="display-2 font-weight-bold text-white">{langKey === 'en' ? 'News & Blog' : 'Τα Νέα Μας'}</h1>
                                    <p className="lead mb-8 text-white font-weight-bold">
                                        {langKey === 'en'
                                            ? 'Learn about our latest news and activity of WeSolve Greece.'
                                            : 'Διάβασε τα πιο πρόφτατα άρθρα για τις δραστηριότητες του WeSolve.'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="position-relative d-none d-lg-block">
                    <div className="shape shape-bottom shape-fluid-x svg-shim text-white">
                        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor" />
                        </svg>
                    </div>
                </div>
                <section className="pt-8 pt-md-11">
                    <div className="container">
                        <div className="row mt-n11 mt-sm-n12">
                            <div className="col-12">
                                <form className="rounded shadow" onSubmit={this.submit}>
                                    <div className="input-group input-group-lg">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text border-0 pr-1">
                                                <i className="fe fe-search"></i>
                                            </span>
                                        </div>
                                        <input
                                            id="search"
                                            type="text"
                                            className="form-control border-0"
                                            aria-label="Search"
                                            placeholder="Search"
                                            value={search}
                                            onChange={this.setSearch}
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text border-0 py-0 pl-1 pr-3">
                                                <span className="h6 text-uppercase text-muted d-none d-md-block mb-0 mr-5">
                                                    {typeof filteredPosts !== 'undefined' ? filteredPosts.length + ' results' : ''}
                                                </span>
                                                <button type="submit" className="btn btn-sm btn-primary pl-md-8 pr-md-8">
                                                    Search
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {typeof filteredPosts !== 'undefined' ? (
                            <div className={filteredPosts.length > 0 ? 'row mt-10' : 'row mt-0 mt-md-10'}>
                                {filteredPosts.length > 0 ? (
                                    filteredPosts.map(({ node }, index) => {
                                        return <PostThumbnail key={node.fields.slug + index} node={node} index={index} />;
                                    })
                                ) : (
                                    <>
                                        <svg width="1129" height="1096" viewBox="0 0 1129 1096" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1068 431.5C1068 712.061 1083.5 1082.5 722 1096C496.392 1096 -248.495 701.863 190.504 477.932C231.541 456.998 344.5 20 753 0C978.608 0 1068 150.939 1068 431.5Z"
                                                fill="#FF6600"
                                                fill-opacity="0.3"
                                            />
                                            <g filter="url(#filter0_d)">
                                                <path
                                                    d="M1072 343H41C38.2386 343 36 345.239 36 348V683C36 685.761 38.2386 688 41 688H1072C1074.76 688 1077 685.761 1077 683V348C1077 345.239 1074.76 343 1072 343Z"
                                                    fill="white"
                                                />
                                            </g>
                                            <path d="M626 626.5H1016" stroke="#F1F4F8" />
                                            <path
                                                d="M637.532 667C643.901 667 649.063 661.627 649.063 655C649.063 648.373 643.901 643 637.532 643C631.163 643 626 648.373 626 655C626 661.627 631.163 667 637.532 667Z"
                                                fill="#336699"
                                                fill-opacity="0.5"
                                            />
                                            <path
                                                d="M36 348.001C36 345.239 38.2386 343.001 41 343.001H557.924C583.059 555 506.676 688.001 506.676 688.001H41C38.2386 688.001 36 685.762 36 683.001V348.001Z"
                                                fill="#ADC2D6"
                                            />
                                            <path
                                                d="M1070.5 338H1007.5C1001.15 338 996 343.149 996 349.5C996 355.851 1001.15 361 1007.5 361H1070.5C1076.85 361 1082 355.851 1082 349.5C1082 343.149 1076.85 338 1070.5 338Z"
                                                fill="#869AB8"
                                            />
                                            <rect x="627" y="398" width="363" height="25" rx="10" fill="#336699" fill-opacity="0.4" />
                                            <rect x="627" y="433" width="258" height="25" rx="10" fill="#336699" fill-opacity="0.4" />
                                            <rect x="627" y="480" width="379" height="16" rx="8" fill="#336699" fill-opacity="0.3" />
                                            <rect x="627" y="509" width="346" height="16" rx="8" fill="#336699" fill-opacity="0.3" />
                                            <rect x="626" y="573.24" width="109" height="16" rx="8" fill="#336699" fill-opacity="0.3" />
                                            <rect x="929" y="573.24" width="76" height="16" rx="8" fill="#336699" fill-opacity="0.3" />
                                            <path
                                                d="M728 577.98C728 575.322 730.101 573.127 732.755 572.988C807.898 569.051 852.318 568.958 928.248 572.985C930.9 573.126 933 575.32 933 577.976V584.076C933 586.901 930.641 589.164 927.817 589.075C852.726 586.709 808.282 586.729 733.181 589.076C730.358 589.165 728 586.902 728 584.078V577.98Z"
                                                fill="#336699"
                                                fill-opacity="0.3"
                                            />
                                            <path
                                                d="M754 545.868C754 543.24 756.046 541.059 758.669 540.884C815.647 537.084 849.761 536.995 907.335 540.88C909.956 541.057 912 543.237 912 545.864V551.788C912 554.631 909.627 556.901 906.787 556.788C850.051 554.516 815.954 554.536 759.211 556.789C756.372 556.902 754 554.632 754 551.79V545.868Z"
                                                fill="#336699"
                                                fill-opacity="0.3"
                                            />
                                            <rect x="626" y="541" width="133" height="16" rx="8" fill="#336699" fill-opacity="0.3" />
                                            <rect x="907" y="541" width="98" height="16" rx="8" fill="#336699" fill-opacity="0.3" />
                                            <rect x="659" y="646" width="62" height="16" rx="8" fill="#336699" fill-opacity="0.3" />
                                            <rect x="721" y="645" width="30" height="17" rx="8.5" fill="#336699" fill-opacity="0.3" />
                                            <rect x="968" y="647" width="52" height="16" rx="8" fill="#336699" fill-opacity="0.3" />
                                            <rect
                                                opacity="0.4"
                                                x="919.095"
                                                y="695"
                                                width="214.87"
                                                height="25"
                                                rx="10"
                                                transform="rotate(37.1435 919.095 695)"
                                                fill="#ADC2D6"
                                            />
                                            <path
                                                d="M1016.08 768.464L1082.4 818.703C1086.8 822.038 1087.67 828.31 1084.34 832.713L1081.32 836.698C1077.98 841.101 1071.71 841.966 1067.31 838.631L1000.98 788.392L1016.08 768.464Z"
                                                fill="#336699"
                                            />
                                            <circle cx="832" cy="631" r="120" fill="#336699" fill-opacity="0.3" />
                                            <path
                                                d="M743.058 607.405C742.069 605.821 741.799 603.881 742.416 602.118C745.492 593.314 750.403 584.364 755.5 578C774.934 553.731 801.5 538 831.5 538.5C853.833 538.872 865.637 542.293 870.211 544.016C871.731 544.589 872.877 545.789 873.578 547.254C876.662 553.703 870.311 560.007 863.647 557.421C855.301 554.182 845.914 552.044 831.5 552.713C806.196 553.888 789.1 563.495 774.5 578C766.875 585.141 760.534 594.336 756.064 605.668C753.936 611.061 746.131 612.321 743.058 607.405Z"
                                                fill="white"
                                                fill-opacity="0.8"
                                            />
                                            <circle cx="832" cy="631" r="112.5" stroke="#336699" stroke-width="15" />
                                            <defs>
                                                <filter
                                                    id="filter0_d"
                                                    x="0"
                                                    y="307"
                                                    width="1129"
                                                    height="433"
                                                    filterUnits="userSpaceOnUse"
                                                    color-interpolation-filters="sRGB"
                                                >
                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                                                    <feOffset dx="8" dy="8" />
                                                    <feGaussianBlur stdDeviation="22" />
                                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                                                </filter>
                                            </defs>
                                        </svg>
                                        <h2 className="ml-auto mr-auto mt-n15 mb-2 text-center text-md-left">
                                            Oops... We didn't find anything matching your search: <strong>"{search}"</strong>
                                        </h2>
                                        <p className="ml-auto mr-auto mt-md-n14 mt-n13 text-center text-md-left">
                                            Try to search for something more general, or check for spelling mistakes
                                        </p>
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="text-center mt-10">
                                <div class="lds-ring">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                        )}
                        {/*<div className="container py-4 py-md-8">
                            <div className="row justify-content-center">
                                <div className="col-10 col-md-8 col-lg-6 col-xl-5">
                                    <Link to="/blog/articles" className="btn btn-block btn-outline-gray-300 d-flex align-items-center">
                                        <span className="mx-auto">See More</span> <i className="fe fe-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                        </div>*/}
                    </div>
                </section>
            </Layout>
        );
    }
}

// export default withPlugin(BlogIndexTemplate, CreatePostPlugin);
export default BlogIndexTemplate;

export const pageQuery = graphql`
    query($langKey: String!) {
        site {
            siteMetadata {
                title
                description
            }
        }
        image: file(relativePath: { eq: "newsroom-blog-discussion.jpeg" }) {
            childImageSharp {
                fixed(quality: 90, width: 2500) {
                    ...GatsbyImageSharpFixed
                }
                fluid(quality: 90) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        allMarkdownRemark(filter: { fields: { langKey: { eq: $langKey } } }, sort: { fields: [frontmatter___date], order: DESC }) {
            edges {
                node {
                    fields {
                        slug
                        langKey
                    }
                    timeToRead
                    excerpt(pruneLength: 100)
                    frontmatter {
                        date(formatString: "MMMM DD, YYYY")
                        title
                        author
                        authorImage {
                            childImageSharp {
                                fixed(height: 36, width: 36, quality: 99) {
                                    ...GatsbyImageSharpFixed
                                }
                            }
                        }
                        featuredImage {
                            childImageSharp {
                                fluid(quality: 95) {
                                    ...GatsbyImageSharpFluid
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
